/* ==========================================================================
   IRON FIT — Package preview page controller  (bundle.html?b=famous)

   One template for all five packages. Everything it shows comes from
   ifz-bundles.js, so the carousel card and this page can never disagree.

   What it owns:
     · the poster, the pitch and the "bought one by one" value block
     · the photo tiles for every piece of kit in the box
     · the extras the card used to hide behind an accordion: pairs of
       5 / 10 / 20 kg plates at the $2.50/kg package rate (capped at 80 kg)
       and the 50 KG dumbbell set at $120
     · one live total, shared by the order block and the phone buy bar
   ========================================================================== */
(function () {
  'use strict';

  var WA_NUMBER = '96181923182';
  var PKG_PLATE_RATE = 2.5;      /* $/kg — the package rate */
  var DBSET_PRICE = 120;

  var LIST = window.IFZ_BUNDLES || [];
  var money = window.IFZCart.money;

  function qs(id) { return document.getElementById(id); }

  /* Every photo on this page ships as WebP too — about half the bytes.
     Through IFZA, always: on Shopify these files live on the CDN with no
     assets/ folder to be relative to, and this page is /pages/package, so
     a bare 'assets/x.webp' resolves to /pages/assets/x.webp and 404s. */
  function url(f) { return window.IFZA ? window.IFZA(f) : f; }
  function webp(f) { return url(f).replace(/\.(jpe?g|png)$/i, '.webp'); }

  function picture(src, alt, cls) {
    return '<picture><source type="image/webp" srcset="' + webp(src) + '">' +
           '<img src="' + url(src) + '" alt="' + alt + '"' +
           (cls ? ' class="' + cls + '"' : '') + ' loading="lazy" decoding="async"></picture>';
  }

  function param() {
    var m = /[?&]b=([^&]+)/.exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }

  var B = LIST.byId(param()) || LIST.byId('famous') || LIST[0];
  if (!B) return;

  /* ------------------------------------------------------------------
     BACK, WHEN YOU CAME FROM THE PLATE CHOOSER

     The four Famous Gym tiers are picked from a chooser inside the package
     rack (ifz-packages.js). Somebody who opened this page from there is
     part-way through deciding how many plates they want, so the back arrow
     has to put them back in front of those four — dropping them on the
     rack instead means making the choice again from the start.

     The flag is set when a tier is tapped and cleared when the chooser is
     closed deliberately, so this only redirects while that decision is
     genuinely still open. Anyone who arrived any other way — a link, a
     search result, the rack itself — gets the ordinary back arrow.
     ------------------------------------------------------------------ */
  (function () {
    var wanted = false;
    try { wanted = sessionStorage.getItem('ifz-pk-tier') === '1'; } catch (e) {}
    if (!wanted) return;

    var back = document.querySelector('.top__back');
    if (!back) return;
    back.innerHTML = '<b>&larr;</b> Back to plate options';
    /* home + #packages is what reopens the rack; the rack sees the same flag
       and puts the chooser back up on top of it */
    back.setAttribute('href', (window.IFZ_URLS && window.IFZ_URLS.home ? window.IFZ_URLS.home : '/') + '#packages');
  })();

  var state = { plates: 0, dbset: false, mix: null };

  /* ======================================================================
     THE PITCH
     ====================================================================== */

  function head() {
    document.title = 'Iron Fit — ' + B.name;

    var poster = qs('poster');
    poster.src = url(B.img);
    poster.alt = B.name + ' — everything included, standing together';

    /* The poster is the biggest thing on the page, so a phone at 3× and a
       retina laptop both ask for more pixels than the master has. Offer the
       1400px variant alongside it and let the browser take the one its own
       screen needs — an ordinary screen still downloads the small one. */
    var SIZES = '(max-width: 980px) calc(100vw - 26px), 42vw';

    if (B.img2x) {
      poster.srcset = url(B.img) + ' 848w, ' + url(B.img2x) + ' 1400w';
      poster.sizes = SIZES;
      qs('posterWebp').srcset = webp(B.img) + ' 848w, ' + webp(B.img2x) + ' 1400w';
      qs('posterWebp').sizes = SIZES;
    } else {
      qs('posterWebp').srcset = webp(B.img);
    }

    var badge = qs('badge');
    badge.textContent = B.badge;
    if (!B.solid) badge.className = 'bposter__badge bposter__badge--ghost';

    qs('kick').textContent = B.best ? 'The one everybody orders' : 'Complete package';
    qs('bname').textContent = B.name;
    qs('btag').textContent = B.tagline;
    qs('blead').innerHTML = B.lead;

    qs('bprice').textContent = money(B.price);

    var was = qs('bwas');
    var chip = qs('bsaveChip');
    if (B.was) {
      was.textContent = money(B.was);
      chip.textContent = 'Save ' + money(B.was - B.price);
      chip.hidden = false;
    } else {
      was.hidden = true;
    }

    if (B.was) {
      qs('bvalue').hidden = false;
      qs('vSep').textContent = money(B.was);
      qs('vPkg').textContent = money(B.price);
      qs('vSave').textContent = money(B.was - B.price);
    }

    if (window.IFZPixel) window.IFZPixel.viewContent(B.name, B.price);

    qs('insideSub').textContent = B.items.length === 1
      ? 'One machine, delivered and installed by our own team.'
      : B.items.length + ' things arrive together, in one delivery, installed in one visit.';
  }

  /* ======================================================================
     SEE IT IN 3D  ·  SEE IT IN YOUR ROOM

     Straight under the price, above everything else, because these are the
     two questions a customer actually has in front of a $900 machine: what
     does it really look like, and will it go in my room. The 3D viewer is
     the same one the machine pages use; the room button hands the fit check
     the machine that is in this package so it opens on the right one.
     ====================================================================== */
  function threeD() {
    if (!B.machine || !window.IFZ3D) return;
    var spec = window.IFZ3D.spec(B.machine);
    if (!spec) return;

    var wrap = document.createElement('div');
    wrap.className = 'b3d';

    var room = document.createElement('a');
    room.className = 'b3d__room';
    room.href = 'fit.html?m=' + B.machine;
    room.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3 10.5 12 4l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1Z"/>' +
      '<path d="M9 21v-6h6v6"/></svg>' +
      '<span>See how it looks in your room<small>One photo — we place it at true size</small></span>' +
      '<i aria-hidden="true">&rarr;</i>';

    var anchor = qs('bvalue').hidden ? qs('blead') : qs('bvalue');
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);

    spec.name = B.items[0] ? B.items[0].name : B.name;
    window.IFZ3D.attach(spec, wrap);      /* adds its own "See it in 3D" button */
    wrap.appendChild(room);
  }

  /* ======================================================================
     WHAT'S IN THE BOX
     ====================================================================== */

  function items() {
    var box = qs('bitems');
    if (B.items.length === 1) box.classList.add('bitems--single');
    B.items.forEach(function (it, i) {
      var tile = document.createElement('article');
      tile.className = 'bitem';
      tile.innerHTML =
        '<div class="bitem__pic">' +
          '<span class="bitem__no">' + (i + 1) + '</span>' +
          picture(it.img, it.name, it.fit === 'contain' ? 'is-fit' : '') +
        '</div>' +
        '<div class="bitem__tx">' +
          '<b></b><small></small>' +
          '<span class="bitem__in">Included</span>' +
        '</div>';
      tile.querySelector('b').textContent = it.name;
      tile.querySelector('small').textContent = it.spec;
      box.appendChild(tile);
    });

    var perks = qs('bperks');
    B.perks.forEach(function (t) {
      var li = document.createElement('li');
      li.textContent = t;
      perks.appendChild(li);
    });
  }


  /* ======================================================================
     HOW THE PLATES COME

     The same 20 kg can arrive as one pair of 10s or two pairs of 5s, and
     which one you want depends on how you train: four 5s let you add 10 kg
     at a time to a bar, a pair of 10s is fewer plates to store. It costs us
     nothing to ask, and getting it wrong means a customer who has to buy
     plates twice.

     Plates always come in pairs — a bar loaded unevenly is no use to
     anybody — so every option below is built from pairs.
     ====================================================================== */

  var PLATE_MIXES = {
    20: [
      { id: '10x2',      label: '2 × 10 kg',                 note: 'Fewest plates to store' },
      { id: '5x4',       label: '4 × 5 kg',                  note: 'Add 10 kg at a time' }
    ],
    40: [
      { id: '20x2',      label: '2 × 20 kg',                 note: 'Fewest plates to store' },
      { id: '10x4',      label: '4 × 10 kg',                 note: 'A good all-round set' },
      { id: '10x2-5x4',  label: '2 × 10 kg + 4 × 5 kg',      note: 'Smallest steps up' }
    ],
    60: [
      { id: '20x2-10x2', label: '2 × 20 kg + 2 × 10 kg',     note: 'Fewest plates to store' },
      { id: '10x6',      label: '6 × 10 kg',                 note: 'A good all-round set' },
      { id: '10x4-5x4',  label: '4 × 10 kg + 4 × 5 kg',      note: 'Smallest steps up' }
    ],
    80: [
      { id: '20x4',      label: '4 × 20 kg',                 note: 'Fewest plates to store' },
      { id: '20x2-10x4', label: '2 × 20 kg + 4 × 10 kg',     note: 'A good all-round set' },
      { id: '20x2-10x2-5x4', label: '2 × 20 + 2 × 10 + 4 × 5 kg', note: 'Smallest steps up' }
    ]
  };

  function plateMixes() { return PLATE_MIXES[B.plateKg] || null; }

  function plateChoice() {
    var mixes = plateMixes();
    if (!mixes) return;

    var box = document.createElement('section');
    box.className = 'bmix is-required';
    box.innerHTML =
      '<h2><span class="bmix__req">Required</span>How would you like the ' + B.plateKg + ' kg?</h2>' +
      '<p class="bmix__sub">Same weight, same price — just tell us which plates to load on the truck. ' +
      '<b>Pick one to carry on.</b></p>' +
      '<div class="bmix__row" role="radiogroup" aria-label="Choose your plates"></div>';

    var row = box.querySelector('.bmix__row');
    mixes.forEach(function (mix, i) {
      var b = document.createElement('button');
      b.type = 'button';
      /* Nothing is pre-picked. It used to default to the first option, which
         meant the question could be scrolled past without being read and the
         plates were chosen for you — this is a real choice about what turns
         up on the truck, so it has to be made rather than inherited. */
      b.className = 'bmix__opt';
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', 'false');
      b.innerHTML = '<b>' + mix.label + '</b><small>' + mix.note + '</small>';
      b.addEventListener('click', function () {
        state.mix = mix;
        [].forEach.call(row.children, function (c) {
          c.classList.remove('is-on');
          c.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-on');
        b.setAttribute('aria-checked', 'true');
        box.classList.remove('is-required');
        box.classList.add('is-done');
        revealExtras();
        refresh();
      });
      row.appendChild(b);
    });

    var inside = qs('bitems').parentNode;          /* the "what's in the box" block */
    inside.parentNode.insertBefore(box, inside.nextSibling);

    /* The extras only exist once the required question is answered — see
       revealExtras(). Nothing to reveal on a package with no plates in it. */
    hideExtras();
  }

  /* ------------------------------------------------------------------
     THE EXTRAS COME SECOND

     Asking "how many MORE plates?" while the visitor has not yet said how
     they want the plates they are already paying for is two plate questions
     at once, and the optional one was landing first. It stays out of the
     way until the required choice is made, so the page asks one thing at a
     time and the order they come in matches the order they matter.
     ------------------------------------------------------------------ */
  function exBox() { return document.querySelector('.bex'); }

  function hideExtras() {
    var ex = exBox();
    if (ex) ex.classList.add('bex--locked');
  }

  function revealExtras() {
    var ex = exBox();
    if (!ex || !ex.classList.contains('bex--locked')) return;
    ex.classList.remove('bex--locked');
  }

  /* Nothing can be ordered until the plate split is answered. The button is
     left visible and disabled rather than hidden, so it is obvious that
     there is a step still to do rather than that the page is broken. */
  function mixNeeded() { return !!plateMixes() && !state.mix; }

  function syncGate() {
    var need = mixNeeded();
    var add = qs('addCart');
    var bar = document.querySelector('.bbar__cta');
    [add, bar].forEach(function (el) {
      if (!el) return;
      el.disabled = need;
      el.classList.toggle('is-locked', need);
      if (need) el.setAttribute('title', 'Choose how you want your plates first');
      else el.removeAttribute('title');
    });
  }

  /* the cart and the WhatsApp message quote the plates the way they were chosen */
  function includesLines() {
    return B.includes.map(function (line) {
      if (state.mix && /kg of rubber olympic plates/i.test(line)) {
        return line + ' — ' + state.mix.label;
      }
      return line;
    });
  }

  /* ======================================================================
     EXTRAS — the picker the package card used to hide
     ====================================================================== */

  function extras() {
    window.IFZPlates(qs('plates'), function (kgNow) {
      state.plates = kgNow;
      refresh();
    });

    var db = document.createElement('div');
    db.className = 'plr plr--check';
    db.setAttribute('role', 'checkbox');
    db.setAttribute('aria-checked', 'false');
    db.tabIndex = 0;
    db.innerHTML =
      '<span class="plr__thumb">' + picture('assets/dbset-open-case-contents-760.jpg', '') + '</span>' +
      '<span class="plr__name plr__name--wrap"><b>50 KG 3-in-1 Dumbbell / Barbell Set</b>' +
      '<small>Optional — never included automatically. Same $120 delivered price; arrives together with your gym.</small></span>' +
      '<span class="plr__price">+ $120</span>' +
      '<span class="plr__box" aria-hidden="true"></span>';
    qs('dbset').appendChild(db);

    function toggle() {
      state.dbset = !state.dbset;
      db.classList.toggle('is-on', state.dbset);
      db.setAttribute('aria-checked', state.dbset ? 'true' : 'false');
      refresh();
    }
    db.addEventListener('click', toggle);
    db.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(); }
    });
  }

  /* ======================================================================
     THE TOTAL — one number, written everywhere at once
     ====================================================================== */

  function extraList() {
    var out = [];
    if (state.plates > 0) {
      /* the package plate rate, which Shopify sells as UPG-PLATES-* */
      out.push({ key: 'upg-plates', kg: state.plates,
                 name: 'Extra plates — ' + state.plates + ' kg',
                 price: state.plates * PKG_PLATE_RATE });
    }
    if (state.dbset) {
      out.push({ key: 'dbset', name: '50 KG 3-in-1 Dumbbell / Barbell Set', price: DBSET_PRICE });
    }
    return out;
  }

  function total() {
    return extraList().reduce(function (s, e) { return s + e.price; }, B.price);
  }

  var added = false;

  function refresh() {
    var t = total();
    var ex = extraList();

    qs('totalN').textContent = money(t);
    qs('barTotal').textContent = money(t);

    /* the phone bar shows the crossed-out price only while nothing is added,
       so it never claims a saving against a total that has extras in it */
    var wasEl = qs('barWas');
    wasEl.textContent = B.was ? money(B.was) : '';
    wasEl.hidden = !B.was || ex.length > 0;

    var lines = qs('totalLines');
    lines.innerHTML = '';
    if (ex.length) {
      [{ name: B.name, price: B.price }].concat(ex).forEach(function (e) {
        var li = document.createElement('li');
        var n = document.createElement('span');
        n.textContent = e.name;
        var p = document.createElement('b');
        p.textContent = money(e.price);
        li.appendChild(n);
        li.appendChild(p);
        lines.appendChild(li);
      });
    }

    if (!added) {
      qs('addCart').textContent = '🛒 Add to cart' + (ex.length ? ' — ' + money(t) : '');
    syncGate();
    }

    wa();
  }

  function wa() {
    var msg = 'Hello Iron Fit — from ironfitstore.online\n' +
              'I want to order ' + B.name + ' at ' + money(B.price) + '.\n';
    /* quote the plates the way the customer chose them — the person reading
       this message is the one loading the truck */
    includesLines().forEach(function (l) { msg += '· ' + l + '\n'; });
    extraList().forEach(function (e) { msg += '+ ' + e.name + ' (' + money(e.price) + ')\n'; });
    msg += 'Total: ' + money(total()) + '\nCash on delivery please.';

    var href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);
    /* The order block's WhatsApp button is the cash-on-delivery button now,
       so there may be nothing to point at. The header's WhatsApp is untouched. */
    var wa = qs('waOrder');
    if (wa) wa.href = href;
    qs('waTop').href = href;
  }

  /* ======================================================================
     ADD TO CART — same item shape the carousel has always written
     ====================================================================== */

  function addToCart() {
    /* The button is disabled while this is true, but a disabled button is a
       presentation detail — the thing that must not happen is a package
       reaching the cart without the plate split that was asked for. */
    if (mixNeeded()) {
      var box = document.querySelector('.bmix');
      if (box) {
        box.classList.add('is-required');
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return false;
    }

    if (added) { window.location.href = window.IFZU('cart-revamp.html'); return true; }

    window.IFZCart.add({
      type: 'package',
      name: B.name,
      price: B.price,
      img: B.img2x || B.img,
      key: B.cod || ('pkg-' + B.id),
      extras: extraList(),
      includes: includesLines()
    });

    added = true;

    var cart = qs('addCart');
    cart.classList.add('is-added');
    cart.textContent = '✓ Added! View cart →';

    var bar = qs('barCta');
    bar.classList.add('is-added');
    bar.textContent = 'Added! View cart →';
  }

  /* ======================================================================
     THE OTHER PACKAGES
     ====================================================================== */

  function others() {
    var row = qs('moreRow');
    var T = window.IFZTiers;

    /* COLLAPSED, like everywhere else.

       This listed every other package one by one — seven cards, and five of
       them the same two posters with a different number printed on them. It
       is the exact pile the plate choosers were built to replace, quietly
       rebuilt at the bottom of every package page.

       Now: ordinary packages as themselves, and one card per family. The
       family THIS package belongs to is kept rather than skipped, because
       from inside the 40 kg box the useful move is usually to the 60. */
    function card(href, img, title, sub, onClick) {
      var a = document.createElement('a');
      a.className = 'more__card';
      a.href = href;
      a.innerHTML =
        '<div class="more__thumb">' + picture(img, '') + '</div>' +
        '<div><b></b><span></span></div>';
      a.querySelector('b').textContent = title;
      a.querySelector('span').textContent = sub;
      if (onClick) a.addEventListener('click', onClick);
      row.appendChild(a);
    }

    var mine = T && T.groupFor(B.id);
    var done = {};

    LIST.forEach(function (o) {
      var g = T && T.groupFor(o.id);

      if (!g) {
        if (o.id === B.id) return;
        card(o.href, o.img, o.name, money(o.price) + ' all-in');
        return;
      }

      if (done[g.key]) return;
      done[g.key] = 1;

      var others = g.tiers.filter(function (t) { return t.id !== B.id; });
      if (!others.length) return;
      var lo = Math.min.apply(null, others.map(function (t) { return t.price; }));

      var isMine = mine && mine.key === g.key;
      card(
        ((window.IFZ_URLS && window.IFZ_URLS.home) || '/') + '#packages',
        g.tiers[0].img,
        isMine ? 'Other plate weights' : g.name,
        others.length + ' options — from ' + money(lo),
        function (e) {
          /* opens where you stand; the href is the fallback if the chooser
             script never arrived */
          if (T && T.open(g.key)) { e.preventDefault(); return; }
          try { sessionStorage.setItem('ifz-pk-tier', g.key); } catch (err) {}
        }
      );
    });
  }

  /* ======================================================================
     GO
     ====================================================================== */

  head();
  threeD();
  items();
  plateChoice();
  extras();
  others();

  qs('barName').textContent = B.name;
  qs('addCart').addEventListener('click', addToCart);

  /* ------------------------------------------------------------------
     ORDERING, CASH ON DELIVERY

     Through the cart rather than EasySell's own button, for the same reason
     as the machine pages: this page carries a plate split, extra plates and
     a dumbbell set. EasySell's product button knows about none of them —
     and this is not even a product page, so it has no product to work from.
     The cart is the one place that holds the whole order, and EasySell's
     COD button is waiting there.
     ------------------------------------------------------------------ */
  (function () {
    var cod = qs('codOrder');
    if (!cod) return;
    cod.addEventListener('click', function () {
      /* addToCart returns false when it refused — the plate split is still
         unanswered — and it has already scrolled that question into view. */
      if (addToCart() === false) return;
    /* Tell the cart page this was "order now", not "add to cart". It opens
       EasySell's own button once the Shopify cart has finished syncing.

       Not /cart?easysell=1 — that is EasySell's own auto-open and it fires
       on page load, which races our sync. Opening the order form against a
       cart that is still half-written is how somebody gets asked to pay for
       the wrong thing. The cart page knows when the sync finished; this
       just tells it what the customer asked for. */
    try { sessionStorage.setItem('ifz-cod-go', '1'); } catch (e) {}
      window.location.href = window.IFZU('cart-revamp.html');
    });
  })();
  qs('barCta').addEventListener('click', addToCart);

  /* Once the real order block is on screen the pinned bar is just a second
     copy of it, so it steps aside — same behaviour as the machine page. */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      qs('bbar').classList.toggle('is-away', entries[0].isIntersecting);
    }, { rootMargin: '-40px 0px -120px 0px' }).observe(qs('orderBox'));
  }

  refresh();
})();
